import { Container, Sprite } from 'pixi.js';
import { END_STEPS, IMAGES, MainSignals, TickCallData } from '../../../../settings/constants';
import StepFrame from './StepFrame';
import { TweenMax, Power1 } from 'gsap';
import { SCENE_FADE_TIME, WALK_END, WALK_START } from '../../../../settings/positions';
import { getSoundSrc } from '../../../../helpers/SoundManager';
import { Howl } from 'howler';

export default class Scene6 extends Container {
  signals: MainSignals;
  frames: StepFrame[] = [];

  character: Sprite;

  show = 0;
  framesStart = 0;
  framesEnd = 0;

  isComplete = false;
  framesActive = false;

  stepsSound?: Howl;

  constructor(signals: MainSignals) {
    super();

    // vars
    this.signals = signals;
    this.progressSetup();

    // parts
    const bg = Sprite.from(IMAGES.BG_6);
    bg.anchor.set(0.5);
    this.addChild(bg);

    this.character = Sprite.from('6-char.png');
    this.character.anchor.set(0.5);
    this.character.alpha = 0;
    this.addChild(this.character);

    this.setSteps();

    // listeners
    signals.tickCall.add(this.tickCall, this);
  }

  // --------------------------------------------------------------
  // Progress
  // --------------------------------------------------------------

  progressSetup(): void {
    this.show = WALK_START;
    this.framesStart = this.show + SCENE_FADE_TIME;
    this.framesEnd = WALK_END;
  }

  checkFramesActive(value: number): void {
    this.setFramesActive(value > this.framesStart && value < this.framesEnd);
  }

  setFramesActive(value: boolean): void {
    if (this.framesActive !== value) {
      this.framesActive = value;

      if (this.framesActive) {
        this.stepsSound = new Howl({ src: getSoundSrc('sfx/steps'), volume: 0.6 });
        this.stepsSound.play();
      } else {
        if (this.stepsSound) {
          this.stepsSound.stop();
        }
      }
    }
  }

  // --------------------------------------------------------------
  // End
  // --------------------------------------------------------------

  journeyComplete(complete: boolean): void {
    if (this.isComplete !== complete) {
      this.isComplete = complete;
      TweenMax.killTweensOf(this.character);

      if (this.isComplete) {
        TweenMax.to(this.character, 1.1, { delay: 0.2, alpha: 1, ease: Power1.easeInOut });
      } else {
        TweenMax.to(this.character, 0.2, { alpha: 0 });
      }
    }
  }

  // --------------------------------------------------------------
  // Step frames
  // --------------------------------------------------------------

  setSteps(): void {
    const frameDuration = (this.framesEnd - this.framesStart) / END_STEPS;
    for (let s = 0; s < END_STEPS; s++) {
      const showValue = this.framesStart + frameDuration * s;
      const hideValue = showValue + frameDuration;
      const step = new StepFrame(s, s === 0 ? this.show : showValue, hideValue);
      this.addChildAt(step, 1);
      this.frames.push(step);
    }
  }

  updateFrames(progress: number): void {
    this.frames.forEach((frame) => {
      frame.update(progress);
    });
  }

  // --------------------------------------------------------------
  // Tick
  // --------------------------------------------------------------

  tickCall(data: TickCallData): void {
    const { scroll } = data;
    this.checkFramesActive(scroll);
    if (scroll >= this.show) {
      this.visible = true;
      this.updateFrames(scroll);
      this.journeyComplete(scroll > this.framesEnd);
    } else {
      this.visible = false;
      this.journeyComplete(false);
    }
  }
}
